export { getUrlFragmentFromConfigKey, geConfigKeyFromUrlFragment } from '../_internal/utils/fragments';
export { getPlaceholderText } from '../_internal/utils/capabilitiesEditorKnownPlaceholders';